import { Outlet } from 'react-router-dom';

function CompaniesLayout() {
  return <Outlet />;
}

export default CompaniesLayout;
